import _StaffService from "../services/staff-service";
import { IStaffService } from "../types/services/staff-service";

const StaffService: IStaffService = new _StaffService();

export default StaffService;
